// extracted by mini-css-extract-plugin
module.exports = {"callToAction":"styles_callToAction__8FcbR","icon":"styles_icon__JZnIS","label":"styles_label__NTpx1"};